import { Badge } from '@/components/ui/badge';
import type { WorkoutAttribution } from '@ergshoot/shared';
import { Building2, Shield, UserRound } from 'lucide-react';

const FALLBACK_ATTRIBUTION: WorkoutAttribution = {
  source: 'hq',
  name: 'ErgShoot HQ',
};

const sourcePresentation = {
  hq: { label: 'HQ', Icon: Shield },
  agent: { label: 'Agent', Icon: UserRound },
  affiliate: { label: 'Gym', Icon: Building2 },
} as const;

export function WorkoutAttributionBadge({
  attribution,
}: {
  attribution?: WorkoutAttribution | null;
}) {
  if (attribution === null) return null;

  const resolved = attribution ?? FALLBACK_ATTRIBUTION;
  const { label, Icon } = sourcePresentation[resolved.source];

  return (
    <Badge
      variant="outline"
      className="gap-1 border-primary/30 bg-primary/5 text-primary"
      title="Workout source"
    >
      <Icon className="h-3 w-3" />
      {label} · {resolved.name}
    </Badge>
  );
}
